import React, { useEffect, useState } from "react";
import { dashboardAPI } from "../../Api/dashboardAPI";
import { toastError, toastInfo, toastSuccess } from "../../utils/toast";
import TableList from "../../components/TableList/TableList";
import SlRadio from "@shoelace-style/shoelace/dist/react/radio";
import Button from "../../components/reusable/Button/Button";
import PageLoader from "../../components/reusable/PageLoader/PageLoader";
import { TransaccionEnTransito } from "../../types/transaccionesEnTransito";
import Pagination from "../../components/reusable/Pagination/Pagination";
import useAuth from "../../hooks/useAuth";

function DesinscripcionesEnTransito() {
  const [loading, setLoading] = useState(false);
  const [desinscripcionesEnTransito, setDesinscripcionesEnTransito] = useState<
    TransaccionEnTransito[]
  >([]);
  const [desinscripcionesSeleccionadas, setDesinscripcionesSeleccionadas] =
    useState<number[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDesinscripciones, setTotalDesinscripciones] = useState(0);
  const { hasPermission } = useAuth();
  const pageLimit = 50;

  const getReservas = async (newPage?: number) => {
    setLoading(true);
    try {
      const { transacciones, totalCount } =
        await dashboardAPI.getDesinscripcionesEnTransito(
          pageLimit,
          newPage ? (newPage - 1) * pageLimit : 0
        );
      setDesinscripcionesEnTransito(transacciones);
      setTotalDesinscripciones(totalCount);
    } catch (error) {
      toastError();
    }
    setLoading(false);
  };

  useEffect(() => {
    getReservas();
  }, []);

  const renderRadioButton = (transaccion: TransaccionEnTransito) => {
    const checked = desinscripcionesSeleccionadas.some(
      (id) => id === transaccion.id
    );
    return (
      <div className="flex w-20 justify-center">
        <SlRadio
          className="pl-2"
          value="1"
          checked={checked}
          onClick={() => {
            if (checked) {
              setDesinscripcionesSeleccionadas((t) =>
                t.filter((id) => id !== transaccion.id)
              );
            } else {
              setDesinscripcionesSeleccionadas((t) => [...t, transaccion.id]);
            }
          }}
        />
      </div>
    );
  };

  const handleDescartarDesinscripcionEnTransito = async (ids: number[]) => {
    if (!ids.length) return;
    try {
      setLoading(true);
      const response = await dashboardAPI.cancelarDesinscripcionesEnTransitoXId(
        ids
      );
      if (response.status === 200) {
        await getReservas();
      } else {
        toastError("Error al intentar cancelar desinscripciones en transito");
      }
    } catch (error) {
      console.log(
        "Error al intentar cancelar desinscripciones en transito",
        error
      );
    } finally {
      setLoading(false);
      setDesinscripcionesSeleccionadas([])
    }
  };

  return (
    <div>
      {loading && <PageLoader />}
      <div className="flex flex-col px-10 py-5">
        <div>
          <div className="flex flex-col">
            <strong className="text-base">
              Desinscripciones no procesadas por Oracle
            </strong>
            <div className="flex flex-row items-center my-2 gap-2">
              <Button
                label="Cancelar desinscripciones seleccionadas"
                onClick={() =>
                  handleDescartarDesinscripcionEnTransito(
                    desinscripcionesSeleccionadas
                  )
                }
                disabled={
                  desinscripcionesSeleccionadas.length === 0 ||
                  !hasPermission(
                    "transacciones_fallidas",
                    "reprocesar_transacciones"
                  )
                }
              />
              {desinscripcionesSeleccionadas.length > 0 && (
                <Button
                  theme="red"
                  label="Limpiar seleccion"
                  onClick={() => setDesinscripcionesSeleccionadas([])}
                />
              )}
            </div>
          </div>
          {desinscripcionesEnTransito.length < 1 && (
            <p>No se encontraron desinscripciones pendientes a reprocesar</p>
          )}
          <TableList
            page="reservas"
            customColumns={[
              {
                columnTitle: "Reprocesar",
                boxContent: (d) => renderRadioButton(d),
              },
            ]}
            list={desinscripcionesEnTransito}
          />
          <Pagination
            onPageChange={setCurrentPage}
            currentPage={currentPage}
            totalCount={totalDesinscripciones}
          />
        </div>
      </div>
    </div>
  );
}

export default DesinscripcionesEnTransito;
